//import axios from "axios";
import * as React from 'react';
import { useRef } from 'react';
import { connect } from 'react-redux';
import { useState, useEffect } from "react";

import { SurveyCreatorComponent, SurveyCreator } from "survey-creator-react";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { render } from 'react-dom';

//email editor
//  https://www.npmjs.com/package/react-email-editor
//  https://www.npmjs.com/package/@types/react-email-editor
import EmailEditor from 'react-email-editor';           

//npm install jquery --save
import $ from 'jquery'
import { SurveyDefinitionRec, SelectedRecProps } from './SurveyDefinitions';

//icons
//  see https://react-icons.github.io/react-icons/icons?name=md
import { MdClose, MdSave, MdDelete, MdAdd, MdSend, MdDeleteForever } from "react-icons/md";
import { getuid, prependOnceListener } from 'process';

//toasts
//npm install --save react-toastify
//multiple toasts showing issue, see https://stackoverflow.com/questions/62578112/react-toastify-showing-multiple-toast
import { toast } from 'react-toastify';
import internal from 'assert';

//material design and react, see https://mui.com/material-ui/getting-started/installation/
//import { Autocomplete, TextField } from "@mui/material";
//npm install @mui/material @emotion/react @emotion/styled

//standard input, textarea controls and react
//  see https://reactjs.org/docs/forms.html#controlled-components

var USER_ID = '00000000-0000-0000-0000-000000000000';
var EMPTY_ID =   '00000000-0000-0000-0000-000000000000';
//TODO: put the survey fields as part of an object
var SURVEY_DEFINITION_ID = EMPTY_ID;  //default to a NEW survey definition

var DEFAULT_CUSTOMBODY = {"counters":{"u_column":1,"u_row":1,"u_content_text":1,"u_content_image":1,"u_content_heading":1,"u_content_divider":1},"body":{"id":"oCFlmN-xqB","rows":[{"id":"_MMIQoou2v","cells":[1],"columns":[{"id":"upZGPJ_QEN","contents":[{"id":"JaY6dCroXK","type":"heading","values":{"containerPadding":"10px","anchor":"","headingType":"h1","fontFamily":{"label":"Arial","value":"arial,helvetica,sans-serif"},"fontSize":"22px","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":null,"_meta":{"htmlID":"u_content_heading_1","htmlClassNames":"u_content_heading"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"text":"<div>Survey regarding Ticket # {TicketNumber}</div>"}},{"id":"xmhEwgj149","type":"text","values":{"containerPadding":"10px","anchor":"","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":null,"_meta":{"htmlID":"u_content_text_1","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"text":"<p style=\"font-size: 14px; line-height: 140%;\">Please take the time to complete the {SurveyName} at {SurveyURL}.  This will help us identify issues we need to work on to improve our service.<br /><br />Ticket information:<br />Ticket #: {TicketNumber}<br />Subject: {TicketSubject}<br />Date: {TicketCreateDate}<br />Model/Part #:  {TicketModel}/{TicketPartNum}<br />Serial #: {TicketSerialNum}<br />Address: {Location}<br /><br />Thank you<br /><br /></p>"}},{"id":"Kj4MnBYuaJ","type":"divider","values":{"width":"100%","border":{"borderTopWidth":"1px","borderTopStyle":"solid","borderTopColor":"#BBBBBB"},"textAlign":"center","containerPadding":"10px","anchor":"","hideDesktop":false,"displayCondition":null,"_meta":{"htmlID":"u_content_divider_1","htmlClassNames":"u_content_divider"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_1","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_1","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true}}],"values":{"popupPosition":"center","popupWidth":"600px","popupHeight":"auto","borderRadius":"10px","contentAlign":"center","contentVerticalAlign":"center","contentWidth":"500px","fontFamily":{"label":"Arial","value":"arial,helvetica,sans-serif"},"textColor":"#000000","popupBackgroundColor":"#FFFFFF","popupBackgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":true},"popupOverlay_backgroundColor":"rgba(0, 0, 0, 0.1)","popupCloseButton_position":"top-right","popupCloseButton_backgroundColor":"#DDDDDD","popupCloseButton_iconColor":"#000000","popupCloseButton_borderRadius":"0px","popupCloseButton_margin":"0px","popupCloseButton_action":{"name":"close_popup","attrs":{"onClick":"document.querySelector('.u-popup-container').style.display = 'none';"}},"backgroundColor":"#e7e7e7","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"preheaderText":"","linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}},"schemaVersion":9}
var DEFAULT_CUSTOMBODYHTML = "Please take the time to complete the {SurveyName} at {SurveyURL}.  This will help us identify issues we need to work on to improve our service.<br /><br />Ticket information:<br />Ticket #: {TicketNumber}<br />Subject: {TicketSubject}<br />Date: {TicketCreateDate}<br />Model/Part #:  {TicketModel}/{TicketPartNum}<br />Serial #: {TicketSerialNum}<br />Address: {Location}<br /><br />Thank you<br /><br /></p>";

var SCHEDULE_EVERYNTHTICKET = 'd986159f-3b89-434d-8150-d0144c61cb2b';
var SCHEDULE_SELECTUSERSONDEMAN = '1b9ab215-2574-482d-ab71-ea32cdbf6f56';
var SCHEDULE_ONETICKETONDEMAND = '4f8849e4-e302-4750-962e-02e8936d87fd';


const creatorOptions = {
    showLogicTab: true,
    isAutoSave: false, //true,
    haveCommercialLicense: true //Add this line
   
};

const defaultJson = {
    pages: [{
        name: "Name",
        elements: [{
            name: "DefaultQuestion",
            title: "Let's get started on creating a new survey:",
            type: "text"
        }]
    }]
};

var _props: SelectedRecProps;

//toast
//const notify = () => toast("Hello world");
const notify = (message: string) => toast(message);

export interface SurveyPortalRec {
    portalID: string;
    id: string;
    refID: string;
    portalName: string;
    infoEmail: string;
    infoEmailPass: string;
    siteUrl: string;
    ticketEmail: string;
    createDate: string
}

export interface RecipientRec {
    optOutFlag: boolean;
    createDate: string;
    createByUserID: string;
    id: string;
    surveyDefinitionID: string;
    emailAddress: string;
}

export interface ScheduleRec {
    id: string;    
    scheduleName: string;
    linkedTo: string;    
    description: string;
    createByUserID: string;    
    createDate: string;
    lastChanged: string;
    lastChangedByID: string;
    surveyList: string
}

export interface RecipientRuleRec {
    id: string;
    surveyDefinitionID: string;
    allowFlag: boolean;
    pattern: string;
    ruleName: string;
    createDate: string;
    createByUserID: string;
    lastChanged: string;
    lastChangedByID: string;
}

var _record: SurveyDefinitionRec;
var _portals: any;
var _recipients: any;
var _schedules: any;  //NOTE: need to allow a blank record, this is not required
var _recipientRules: any;


export function SurveyDefinition(props: SelectedRecProps) {

    const [state, setstate] = useState({isLoaded: false
                                        , record: _record
                                        , portals: _portals
                                        , recipients: _recipients
                                        , schedules: _schedules
                                        , recipientRules: _recipientRules
                                      });

    //userID is sent in as part of the props
    USER_ID = props.userID;

    //trying to get speed on the text boxes here
    const surveyNameRef: any = useRef();  //value shows up in the form with this
    const customSubjectRef: any = useRef();  //value shows up in the form with this
    const repetitionRef: any = useRef();  //value shows up in the form with this
    const portalRowRef: any = useRef();
    const ticketFieldsULRef: any = useRef();

    //show/hide table rows based on schedule
    const repetitionRowRef: any = useRef();
    const ticketRecipientRulesRowRef: any = useRef();

    const defaultOnDemandRef: any = useRef();
    const defaultOnDemandRowRef: any = useRef();

    const sendButtonTDRef: any = useRef();

    const saveSurveyHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        var baseUrl = process.env.REACT_APP_SURVEY_FUNCTIONCODE_SAVEDEFINITION;
        var url = buildUrlReplace(baseUrl, "{id}", _record.id);

        //this button is NOT picking up changes made to the survey questions
        //  need to update the _record.surveyDetail value before saving
        //_record.surveyDetail = creator.JSON;  //this gets an error saving in the fn app
        _record.surveyDetail = JSON.stringify(creator.JSON);

        //custom email body
        emailEditorRef.current.editor.exportHtml((data: { design: any; html: any; }) => {
            const { design, html } = data;
            _record.customBody = JSON.stringify(design);
            _record.customBodyHtml = html;

            //there are some text box values to capture on the _record object
            _record.surveyName = surveyNameRef.current.value;
            _record.customSubject = customSubjectRef.current.value;

            //need to make sure there is a portals value
            if ((_record.portalID == null) || (_record.portalID == EMPTY_ID)) {
                _record.portalID = _portals[0].portalID;
                _record.portalName = _portals[0].portalName;
            }

            //make sure this is a number between 1 and 10
            
            if (isNaN(repetitionRef.current.value))
                _record.repetition = 3;
            else if ((repetitionRef.current.value <0) || (repetitionRef.current.value > 10))
                _record.repetition = 3;
            else
                _record.repetition = repetitionRef.current.value;

            //make sure of the default on demand flag
            if (_record.scheduleID == SCHEDULE_ONETICKETONDEMAND) { 
                _record.defaultOnDemand = defaultOnDemandRef.current.checked;
            }
            else
                _record.defaultOnDemand = false;

            //TODO: save all parts of the survey with one call (survey, recipients, recipientRules, etc)
            saveSurvey(url);

            //save the recipient rules
            //  make sure the survey defn id is set
            _recipientRules.map(function(rec:RecipientRuleRec) {
                rec.surveyDefinitionID =  _record.id;
            });

            var baseUrl2 = process.env.REACT_APP_SURVEY_FUNCTIONCODE_SAVERECIPIENTRULES;
            var url2 = buildUrlReplace(baseUrl2, "{id}", _record.id);
            saveRecipientRules(url2);

            //save the recipients
            _recipients.map(function(rec:RecipientRec) {
                rec.surveyDefinitionID =  _record.id;
            });
            var baseUrl3 = process.env.REACT_APP_SURVEY_FUNCTIONCODE_SAVERECIPIENTS;
            var url3 = buildUrlReplace(baseUrl3, "{id}", _record.id);
            saveRecipients(url3);            

            //if this was a new survey, we now have an id
            // if (_props.mode == "new") {
            //     //force a reload
            //     setstate({isLoaded: false, record: _record, portals: state.portals, recipients: state.recipients, schedules: state.schedules}); 
            // }
            setstate({isLoaded: false, record: _record, portals: state.portals, recipients: state.recipients, schedules: state.schedules, recipientRules: state.recipientRules}); 
        });
        
        //there are some text box values to capture on the _record object
        // _record.surveyName = surveyNameRef.current.value;
        // _record.customSubject = customSubjectRef.current.value;
        // saveSurvey(url);

        // //if this was a new survey, we now have an id
        // if (_props.mode == "new") {
        //     //force a reload
        //     setstate({isLoaded: false, record: _record, portals: state.portals, recipients: state.recipients, schedules: state.schedules}); 
        // }
      };

    //send btn handler
    const sendSurveyHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        console.log('send survey button clicked');

        var baseUrl = process.env.REACT_APP_SURVEY_FUNCTIONCODE_SENDEMAILNOW;
        var url = buildUrlReplace(baseUrl, "{id}", _record.id);        
        if (_record.scheduleID == SCHEDULE_ONETICKETONDEMAND) {
            //need to get a ticket refID here
            var refID = prompt('Which Ticket RefId to send now?');
            url = buildUrlReplace(baseUrl, "{id}", _record.id + '/' + refID);       

        }
        GetJsonResult(url); 
        notify("The survey link has been sent!");
        
        if ((sendButtonTDRef != null) && (sendButtonTDRef.current != null)) {
            sendButtonTDRef.current.className = "hidden";
        }

    };      

    //close button handler
    const closeSurveyHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        console.log('close survey button clicked');
        //alert('close survey button clicked');
        _props.refreshList('close survey button clicked');
    };    
    
    const deleteSurveyHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        console.log('delete survey button clicked');
        //alert('close survey button clicked');
        if (confirm("Delete this survey definition?")) {
            var baseUrl = process.env.REACT_APP_SURVEY_FUNCTIONCODE_DELETESURVEY;
            var url = buildUrlReplace(baseUrl, "{id}", _record.id);        
            GetJsonResult(url); 
            notify("The survey has been deleted!"); 
            _props.refreshList('close survey button clicked');          
        }
    };      


    //email editor, see   https://www.npmjs.com/package/react-email-editor                                    
    const emailEditorRef: any = useRef(null);    
    const exportEmailEditor = () => {
        emailEditorRef.current.editor.exportHtml((data: { design: any; html: any; }) => {
            const { design, html } = data;
            //   console.log('exportHtml', html);
        
            //saving email editor, see https://medium.com/unlayer-blog/creating-a-drag-n-drop-email-editor-with-react-db1e9eb42386
            _record.customBody = JSON.stringify(design);
            setstate({isLoaded: true, record: _record, portals: state.portals, recipients: state.recipients, schedules: state.schedules, recipientRules: state.recipientRules}); 

            var baseUrl = process.env.REACT_APP_SURVEY_FUNCTIONCODE_SAVEDEFINITION;
            var url = buildUrlReplace(baseUrl, "{id}", SURVEY_DEFINITION_ID);
        
            saveSurvey(url);
        });
      };

      const onEmailEditorLoad = () => {
        //alert('onEmailEditorLoad');
        // you can load your template here;
        // const templateJson = {};
        //emailEditorRef.current.editor.loadDesign(_record.customBody);
      };

      const onEmailEditorReady = () => {
        //NOTE: ready event comes after load event
        //alert('onEmailEditorReady');
        if ((_record.customBody != null) 
            && (_record.customBody.length > 0)
            && (emailEditorRef != null)
            && (emailEditorRef.current != null)
            )
            emailEditorRef.current.editor.loadDesign(JSON.parse(_record.customBody));
            
      };

      //end email editor
 

    //tabs (kind-of)
    const tabClick = (event: React.MouseEvent<HTMLSpanElement>, selectedTab: string) => {
        if (selectedTab=="Survey") {
            $("#divSurvey").show();
            $("#divCreator").hide();
            $("#divSurvey").removeClass("hidden");

            $("#tdSurvey").addClass("tabclicked");
            $("#tdCreator").removeClass("tabclicked");
        }
        else if (selectedTab=="Creator") {
            $("#divSurvey").hide();
            $("#divCreator").show();
            $("#divCreator").removeClass("hidden");

            $("#tdSurvey").removeClass("tabclicked");
            $("#tdCreator").addClass("tabclicked");
         }
        setstate({isLoaded: true, record: state.record, portals: state.portals, recipients: state.recipients, schedules: state.schedules, recipientRules: state.recipientRules}); 
    }

    

    //form change handlers


    const handlePortalChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        //onchange events,  https://stackoverflow.com/questions/53943737/typescript-react-component-that-accepts-onchange-for-both-textarea-and-input
        //                  https://stackoverflow.com/questions/41077657/react-onchange-set-but-input-still-read-only
        _record.portalID = e.target.value;
        setstate({isLoaded: state.isLoaded, record: _record, portals: state.portals, recipients: state.recipients, schedules: state.schedules, recipientRules: state.recipientRules}); 
    };

    const handleScheduleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        //onchange events,  https://stackoverflow.com/questions/53943737/typescript-react-component-that-accepts-onchange-for-both-textarea-and-input
        //                  https://stackoverflow.com/questions/41077657/react-onchange-set-but-input-still-read-only
        _record.scheduleID = e.target.value;
        //need to show/hide controls based on which schedule has been selected
        //on demand - hide schedule repetition; ticket recipient rules
        //show/hide rows based on schedule
        setVisibilityBySchedule();
        // if ((repetitionRowRef != null) && (repetitionRowRef.current != null))  {
        //     if (_record.scheduleID == SCHEDULE_EVERYNTHTICKET)
        //         repetitionRowRef.current.className = ""; 
        //     else
        //         repetitionRowRef.current.className = "hidden";     
        // }
            
        // if ((ticketRecipientsRowRef != null) && (ticketRecipientsRowRef.current != null)) {
        //     if ((_record.scheduleID == SCHEDULE_EVERYNTHTICKET) || (_record.scheduleID == SCHEDULE_ONETICKETONDEMAND))
        //         ticketRecipientsRowRef.current.className = ""; 
        //     else
        //         ticketRecipientsRowRef.current.className = "hidden";     
        // }

        // if ((ticketFieldsULRef != null) && (ticketFieldsULRef.current != null)) {
        //     if ((_record.scheduleID == SCHEDULE_EVERYNTHTICKET) || (_record.scheduleID == SCHEDULE_ONETICKETONDEMAND))
        //         ticketFieldsULRef.current.className = ""; 
        //     else
        //         ticketFieldsULRef.current.className = "hidden";     
        // }
 


        setstate({isLoaded: state.isLoaded, record: _record, portals: state.portals, recipients: state.recipients, schedules: state.schedules, recipientRules: state.recipientRules}); 
    };

    const handleCustomBodyChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        //onchange events,  https://stackoverflow.com/questions/53943737/typescript-react-component-that-accepts-onchange-for-both-textarea-and-input
        //                  https://stackoverflow.com/questions/41077657/react-onchange-set-but-input-still-read-only
        //update textarea value
        _record.customBody = e.target.value;
        setstate({isLoaded: state.isLoaded, record: _record, portals: state.portals, recipients: state.recipients, schedules: state.schedules, recipientRules: state.recipientRules}); 
      };


    //recipients handlers
    //for handler with input box, see https://reactjs.org/docs/refs-and-the-dom.html
    const newRecipientInput: any = React.createRef();

    const addRecipientHandler = (event: any) => {  
        const today = new Date();
        var emailAddress = newRecipientInput.current.value;
        if (isValidEmail(emailAddress)) {
            var rec: any ={
                optOutFlag: false,
                createDate: today.toLocaleDateString(),
                createByUserID: USER_ID,
                id: EMPTY_ID,
                surveyDefinitionID: SURVEY_DEFINITION_ID,
                emailAddress: emailAddress
                };

            _recipients.push(rec);                
            setstate({isLoaded: state.isLoaded, record: state.record, portals: state.portals, recipients: _recipients, schedules: state.schedules, recipientRules: state.recipientRules}); 
        }
        else {
            notify('The email address is NOT valid');
        }
    };      
    
    const deleteRecipientHandler = (event: any, selectedID: string) => {  
        //remove the record with the selected key from the _recipients collection
        var index = _recipients.map(function(rec:RecipientRec) {
            return rec.id
        }).indexOf(selectedID);

        _recipients.splice(index, 1);
        setstate({isLoaded: state.isLoaded, record: state.record, portals: state.portals, recipients: _recipients, schedules: state.schedules, recipientRules: state.recipientRules}); 
    };  
    
    //recipientRules handlers
    //for handler with input box, see https://reactjs.org/docs/refs-and-the-dom.html
    const newRuleNameInput: any = React.createRef();
    const newAllowFlagInput: any = React.createRef();
    const newPatternInput: any = React.createRef();

    const addRecipientRuleHandler = (event: any) => {  
        const today = new Date();
        var ruleName = newRuleNameInput.current.value;
        var pattern = newPatternInput.current.value;
        var allowFlag = false;
        if ((newAllowFlagInput.current.value == true) || (newAllowFlagInput.current.value == 'on'))
            allowFlag = true;
            
        if (ruleName != '') {
            //add new record to the list
            //no need to save the entire record at this time??

            var rec: any ={
                id: EMPTY_ID,
                surveyDefinitionID: SURVEY_DEFINITION_ID,
                allowFlag: allowFlag,
                pattern: pattern,
                ruleName: ruleName,
                createDate: today.toLocaleDateString(),
                createByUserID: USER_ID,
                lastChanged: today.toLocaleDateString(),
                lastChangedByID: USER_ID
                };
            
            _recipientRules.push(rec);

            newRuleNameInput.current.value = '';
            newPatternInput.current.value = '';
            newAllowFlagInput.current.value = '';

            setstate({isLoaded: state.isLoaded, record: state.record, portals: state.portals, recipients: state.recipients, schedules: state.schedules, recipientRules: _recipientRules}); 
        }
        else {
            notify('Please enter a rule name and a pattern.  Use * for wildcard.');
        }
    };      
    
    const deleteRecipientRuleHandler = (event: any, selectedID: string) => {  
        //remove the record with the selected key from the _recipients collection
        //this is NOT saved to the db here
        var index = _recipientRules.map(function(rec:RecipientRuleRec) {
            return rec.id
        }).indexOf(selectedID);

        _recipientRules.splice(index, 1);

        setstate({isLoaded: state.isLoaded, record: state.record, portals: state.portals, recipients: state.recipients, schedules: state.schedules, recipientRules: _recipientRules}); 

    };   
 
       
    function isValidEmail(email: string) {
        return /\S+@\S+\.\S+/.test(email);
    }   

    _props = props;
    if (_props.mode == 'hidden') {
        //SurveyDefinition component is hidden
        return (
            <div></div>
        )
    }

    //TODO: how to distinguish between a new survey, and the last survey that was loaded?
    //      edit a survey, close it, then create a new survey, below is causing old data to be loaded on the new survey
    //      perhaps status.isLoaded can inform this???
     if ((state.isLoaded == false) && (_props.mode == 'new'))
        SURVEY_DEFINITION_ID = EMPTY_ID;
    else {
        var id = SURVEY_DEFINITION_ID;
        if (props.mode == 'new') {
            //if a new record has been saved, the props will still say new, as the props are read-only
            if (_record != null)
                id = _record.id;
            else
                id = EMPTY_ID;
            
        }
        else if ((props.id == null) || (props.id =='')) {
            const path = window.location.search; //.pathname;
            if (path.includes("surveydefinitionid")) {
                var id = path.substring(path.indexOf("=") + 1);
                if (id.indexOf("&") > 0) {
                    id = id.substring(0, id.indexOf("&") - 1)
                }
            }
        }
        else {
            id = props.id;
        }

        SURVEY_DEFINITION_ID = id;
    }
    
    const creator = new SurveyCreator(creatorOptions);

    if (state.isLoaded == false) {
        const today = new Date();
        var blankSchedule = {
            createByUserID: EMPTY_ID,
            createDate: today.toLocaleDateString(),
            description: '',
            id: EMPTY_ID, 
            lastChanged: today.toLocaleDateString(),
            lastChangedByID: EMPTY_ID,
            linkedTo: '',
            scheduleName: 'none',
            surveyList: ''
        }

        //get the json for the survey definition questions 
        //get the data for the existing (or new) survey (not the json for the survey questions, but the other info that we need)
        //NOTE: Each survey is built for a particular survey (one to one)
        //      if you want to use the survey for a different portal, clone the survey   

        var surveydefn: any;
        if ((SURVEY_DEFINITION_ID == '') || (SURVEY_DEFINITION_ID == EMPTY_ID)) {
            //set up the default survey questions
            creator.text = JSON.stringify(defaultJson);

            const today = new Date()
            _record = {
                id: EMPTY_ID,
                surveyName: 'New Survey',
                surveyDetail: JSON.stringify(defaultJson),
                customSubject: "Survey for Ticket # {TicketNumber}, thanks for participating!",
                customBody: JSON.stringify(DEFAULT_CUSTOMBODY),
                customBodyHtml: DEFAULT_CUSTOMBODYHTML,
                portalID: EMPTY_ID, 
                portalName: "SELECT PORTAL",
                createDate: today.toLocaleDateString(),
                createByUserID: USER_ID,
                lastChanged: today.toLocaleDateString(),
                lastChangedByID: USER_ID,
                numRecs: 0,
                numSurveysSent: 0,
                scheduleID: EMPTY_ID,
                scheduleName: '',
                repetition: 3,
                aliasID: EMPTY_ID,
                defaultOnDemand: false
              };

            _recipients =[{
                optOutFlag: false,
                createDate: today.toLocaleDateString(),
                createByUserID: USER_ID,
                id: EMPTY_ID,
                surveyDefinitionID: EMPTY_ID,
                emailAddress: 'recipient email address'
                }
            ]

            _recipientRules =[{
                id: EMPTY_ID,
                surveyDefinitionID: EMPTY_ID,
                allowFlag: false,
                pattern: '',
                ruleName: '',
                createDate: today.toLocaleDateString(),
                createByUserID: USER_ID,
                lastChanged: today.toLocaleDateString(),
                lastChangedByID: USER_ID
                }


            ]



            //now get other data
            var baseUrl = process.env.REACT_APP_SURVEY_FUNCTIONCODE_LISTPORTALS;
            var url = buildUrlReplace(baseUrl, "{id}", USER_ID);
            _portals = GetJsonResult(url);  

            //if there is only one portal, that will be the one
            if (_portals.length == 1) {
                _record.portalID = _portals[0].portalID;
                _record.portalName = _portals[0].portalName;
            }

            baseUrl = process.env.REACT_APP_SURVEY_FUNCTIONCODE_LISTSCHEDULES;
            url = buildUrlReplace(baseUrl, "{id}", EMPTY_ID);
            _schedules = GetJsonResult(url);  
            _schedules.unshift(blankSchedule);

            creator.text = _record.surveyDetail;
        }
        else {
            //get the survey questions
            // var baseUrl = process.env.REACT_APP_SURVEY_FUNCTIONCODE_GETDEFINITIONDETAIL;
            // var url = buildUrlReplace(baseUrl, "{id}", SURVEY_DEFINITION_ID);
            // var jsonString = GetJsonResult(url);
            // //display it
            // creator.text = jsonString;// JSON.stringify(defaultJson);// JSON.stringify(jsonString);
    
            //now get the other data
            //survey already exists, get the data and show it
            var baseUrl = process.env.REACT_APP_SURVEY_FUNCTIONCODE_GETDEFINITION;
            var url = buildUrlReplace(baseUrl, "{id}", SURVEY_DEFINITION_ID);
            surveydefn = GetJsonResult(url);  

            _record = surveydefn;
            _record.lastChangedByID = USER_ID;

            creator.text = _record.surveyDetail;

            _portals = [
                {portalName:_record.portalName, portalID: _record.portalID}
            ] 

            url = process.env.REACT_APP_SURVEY_FUNCTIONCODE_LISTSCHEDULES;
            _schedules = GetJsonResult(url);  

            _schedules.unshift(blankSchedule);

            //get the list of general recipients (always get a survey email)
            var results: any;
            baseUrl = process.env.REACT_APP_SURVEY_FUNCTIONCODE_GETRECIPIENTS;
            url = buildUrlReplace(baseUrl, "{id}", _record.id);
            results = GetJsonResult(url);  
            _recipients = results;

            //get the list of recipient rules for ticket email addresses
            var results: any;
            baseUrl = process.env.REACT_APP_SURVEY_FUNCTIONCODE_GETRECIPIENTRULES;
            url = buildUrlReplace(baseUrl, "{id}", _record.id);
            results = GetJsonResult(url);  
            _recipientRules = results;
        }
        
        //just grabbed all the data here, so use the collections
        setstate({isLoaded: true
                , record: _record
                , portals: _portals
                , recipients: _recipients
                , schedules: _schedules
                , recipientRules: _recipientRules});  


    }   //state.isLoaded == false


    //seeing if we can get the typing faster, onchange is so slow
    useEffect(() => {
        //see https://dmitripavlutin.com/react-useref-guide/
        if ((surveyNameRef != null) && (surveyNameRef.current != null)) {
            surveyNameRef.current.value = _record.surveyName; 
            surveyNameRef.current.select();
            surveyNameRef.current.focus();
        }
         
        if ((customSubjectRef != null) && (customSubjectRef.current != null))
            customSubjectRef.current.value = _record.customSubject; 

        if ((repetitionRef != null) && (repetitionRef.current != null))
            repetitionRef.current.value = _record.repetition;   
            
        //hide portals list if only one portal in the list
        if ((portalRowRef != null) && (portalRowRef.current != null) && (state.portals.length <= 1))
            portalRowRef.current.className = "hidden";

        if ((defaultOnDemandRef != null) && (defaultOnDemandRef.current != null))
            defaultOnDemandRef.current.checked = _record.defaultOnDemand;             

        //show/hide rows based on schedule
        setVisibilityBySchedule();
        // if ((repetitionRowRef != null) && (repetitionRowRef.current != null))  {
        //     if (_record.scheduleID == SCHEDULE_EVERYNTHTICKET) 
        //         repetitionRowRef.current.className = ""; 
        //     else 
        //         repetitionRowRef.current.className = "hidden";     
        // }

        // if ((ticketRecipientsRowRef != null) && (ticketRecipientsRowRef.current != null)) {
        //     if ((_record.scheduleID == SCHEDULE_EVERYNTHTICKET) || (_record.scheduleID == SCHEDULE_ONETICKETONDEMAND))
        //         ticketRecipientsRowRef.current.className = ""; 
        //     else
        //         ticketRecipientsRowRef.current.className = "hidden";     
        // }

        // if ((ticketFieldsULRef != null) && (ticketFieldsULRef.current != null)) {
        //     if ((_record.scheduleID == SCHEDULE_EVERYNTHTICKET) || (_record.scheduleID == SCHEDULE_ONETICKETONDEMAND))
        //         ticketFieldsULRef.current.className = ""; 
        //     else
        //         ticketFieldsULRef.current.className = "hidden";     
        // }
           
      }, []);

      const setVisibilityBySchedule = () => {
        if ((repetitionRowRef != null) && (repetitionRowRef.current != null))  {
            if (_record.scheduleID == SCHEDULE_EVERYNTHTICKET) 
                repetitionRowRef.current.className = ""; 
            else 
                repetitionRowRef.current.className = "hidden";     
        }

        ticketRecipientRulesRowRef.current.className = "hidden";
        // if ((ticketRecipientRulesRowRef != null) && (ticketRecipientRulesRowRef.current != null)) {
        //     if (_record.scheduleID == SCHEDULE_ONETICKETONDEMAND)
        //         ticketRecipientRulesRowRef.current.className = ""; 
        //     else
        //         ticketRecipientRulesRowRef.current.className = "hidden";     
        // }

        if ((ticketFieldsULRef != null) && (ticketFieldsULRef.current != null)) {
            if ((_record.scheduleID == SCHEDULE_EVERYNTHTICKET) || (_record.scheduleID == SCHEDULE_ONETICKETONDEMAND))
                ticketFieldsULRef.current.className = ""; 
            else
                ticketFieldsULRef.current.className = "hidden";     
        }  
        
        if ((defaultOnDemandRowRef != null) && (defaultOnDemandRowRef.current != null)) {
            if (_record.scheduleID == SCHEDULE_ONETICKETONDEMAND)
                defaultOnDemandRowRef.current.className = ""; 
            else
                defaultOnDemandRowRef.current.className = "hidden";     
        }

      }


    //make sure survey json is shown
    creator.text = _record.surveyDetail;

    return (
        <div className='width100pct'>
           
            <table className="width100pct">
                <tbody className='width100pct'>
                    <tr>
                        <td id="tdSurvey" className="width50pct tab tabclicked" onClick={event => tabClick(event, "Survey")} ><span>Survey Setup</span></td>
                        <td id="tdCreator" className="width50pct tab" onClick={event => tabClick(event, "Creator")} ><span>Survey Creator</span></td>
                        <td className='rightAlign'><button onClick={deleteSurveyHandler}><MdDeleteForever style={{ color: 'red'}}/></button></td>
                        <td className='rightAlign'></td>
                        <td className='rightAlign' ref={sendButtonTDRef}><button onClick={sendSurveyHandler}><MdSend style={{ color: 'blue'}}/></button></td>
                        <td className='rightAlign'></td>
                        <td className='rightAlign'><button onClick={saveSurveyHandler}><MdSave style={{ color: 'blue'}}/></button></td>
                        <td className='rightAlign'><button onClick={closeSurveyHandler}><MdClose/></button></td>
                    </tr>
                </tbody>
            </table>
            <div id="divSurvey">
                <table width='100%'>
                    <tbody className='width100pct'>
                        <tr>
                            <td><b>Survey Name:</b> </td>
                            <td>
                                <input type='text' size={100} 
                                    className='width50pct'
                                    maxLength={255}
                                    ref={surveyNameRef}
                                    // autoFocus
                                    >
                                </input>
                            </td>
                        </tr>
                        
                        <tr ref={portalRowRef}>
                            <td><b>Portal:</b> </td>
                            <td>                            
                                <select id="cboPortalID" 
                                    title="Portal List"
                                    onChange={handlePortalChange}
                                    >
                                    {_portals.map((rec: SurveyPortalRec) => (
                                        <option key={rec.portalID} value={rec.portalID} >
                                        {rec.portalName}
                                        </option>
                                    ))}
                                </select>  
                            </td>
                        </tr>
                        
                        <tr>
                            <td><b>Schedule:</b> </td>
                            <td>                            
                                <select id="cboScheduleID" 
                                    title="Schedule List"
                                    value={_record.scheduleID}
                                    onChange={handleScheduleChange}
                                    >
                                    {_schedules.map((rec: ScheduleRec) =>
                                    (
                                        <option key={rec.id} value={rec.id}  >
                                        {rec.scheduleName + ' - ' + rec.description}
                                        </option>
                                    )
                                    )
                                    }
                                </select>  
                            </td>
                        </tr>  

                        <tr ref={defaultOnDemandRowRef}>
                            <td><b>Default on Demand?</b></td>
                            <td>                            
                            <input type='checkbox' 
                                    className='width50pct'
                                    ref={defaultOnDemandRef}
                                    style={{ width: '50px' }}
                                    >
                                </input>
                            </td>
                        </tr>  

                         <tr ref={repetitionRowRef}>
                            <td><b>Schedule Repetition</b><br />(if applicable): </td>
                            <td>                            
                            <input type='number' 
                                    size={2} 
                                    className='width50pct'
                                    min={1}
                                    max={9}
                                    maxLength={1}
                                    ref={repetitionRef}
                                    style={{ width: '50px' }}
                                    >
                                </input>
                            </td>
                        </tr>                                               
                        {/* {_record.id != EMPTY_ID && */}
                        <tr>
                            <td className='topAlign'><b>General Recipients:</b><br />(always receive an email)</td>
                            <td>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td colSpan={2}>
                                                <input type="text" ref={newRecipientInput} size={50} maxLength={100} />
                                                <button onClick={event => addRecipientHandler(event)} title='Add new recipient'><MdAdd/></button>
                                            </td>
                                        </tr>
                                        {_recipients.map((rec: RecipientRec) => 
                                                <tr key={rec.id}>
                                                    <td>{rec.emailAddress}</td>
                                                    <td>
                                                        <button onClick={event => deleteRecipientHandler(event, rec.id)} title='Delete this recipient'><MdDelete/></button>
                                                    </td>
                                                </tr>
                                        )}
                                   </tbody>
                                </table>

                            </td>
                        </tr> 
                        {/* }   */}
                        {/* {_record.id != EMPTY_ID && */}
                        <tr ref={ticketRecipientRulesRowRef}>
                            <td className='topAlign'><b>Ticket Recipient Rules:</b></td>
                            <td>
                                <table>
                                    <tbody>
                                        <tr className='outline'>
                                            <td>
                                                New Rule Name: <input type="text" ref={newRuleNameInput} size={40} maxLength={50} />
                                            </td>
                                            <td>
                                                Allow? <input type="checkbox" ref={newAllowFlagInput} />
                                            </td>
                                            <td colSpan={2}>
                                                Pattern:
                                                <input type="text" ref={newPatternInput} size={40} maxLength={255} title="Use * for wildcard. To allow any email from the CloudCover domain, enter:  *@cloudcover.it" />
                                                <button onClick={event => addRecipientRuleHandler(event)} title='Add new recipient rule'><MdAdd/></button>
                                            </td>
                                        </tr>
                                        {_recipientRules.map((rec: RecipientRuleRec) => 
                                                <tr key={rec.id}>
                                                    <td>{rec.ruleName}</td>
                                                    <td>{rec.allowFlag}</td>
                                                    <td>{rec.pattern}</td>
                                                    <td>
                                                        <button onClick={event => deleteRecipientRuleHandler(event, rec.id)} title='Delete this recipient rule'><MdDelete/></button>
                                                    </td>
                                                </tr>
                                        )}
                                   </tbody>
                                </table>

                            </td>
                        </tr> 
                        {/* }                           */}

                        <tr>
                            <td><b>Custom Subject:</b></td>
                            <td>
                                <input type='text' 
                                    size={100} 
                                    className='width50pct' 
                                    maxLength={255}
                                    ref={customSubjectRef}
                                    >
                                </input>
                            </td>
                        </tr>
                        <tr className="hidden">
                            <td>Custom Body:</td>
                            <td>
                                <textarea id="txtCustomBody" rows={4} cols={100} 
                                    value={_record.customBody} 
                                    onChange={handleCustomBodyChange}>
                                </textarea>
                            </td>
                        </tr>
                     
                        <tr>
                            <td >
                                <b>Custom Body:</b><br/>
                                Fields can include:<br/>
                                (Case Sensitive)
                                <ul>
                                    <li>&#123;SurveyName&#125;</li>
                                    <li>&#123;SurveyURL&#125;</li>
                                </ul>
                                <ul ref={ticketFieldsULRef}>  
                                    <li>&#123;TicketNumber&#125;</li>
                                    <li>&#123;TicketSubject&#125;</li>
                                    <li>&#123;TicketCreateDate&#125;</li>
                                    <li>&#123;TicketLastUpdated&#125;</li>

                                    <li>&#123;TicketModel&#125;</li> 
                                    <li>&#123;TicketPartNum&#125;</li> 
                                    <li>&#123;TicketSerialNum&#125;</li>
                                    <li>&#123;TicketAssetName&#125;</li> 
                                    <li>&#123;TicketSLA&#125;</li>
                                    <li>&#123;TicketCustomer&#125;</li>
                                    <li>&#123;TicketSiteContact&#125;</li>
                                    <li>&#123;TechnicalContact&#125;</li>
                                    <li>&#123;ContactNumber&#125;</li>
                                    <li>&#123;ContractNumber&#125;</li>
                                    <li>&#123;Location&#125;</li>
                                </ul>
                            </td>
                            <td className="topAlign">
                                {/* <button onClick={exportEmailEditor}>Save Custom Body HTML</button>  */}
                                <EmailEditor ref={emailEditorRef} onLoad={onEmailEditorLoad} onReady={onEmailEditorReady}/>
                            </td>
                        </tr>

                    </tbody>
                </table> 
            </div>


            <div id="divCreator" className="hidden"> 
                <SurveyCreatorComponent creator={creator} />
            </div>

        </div>

        
    )
}



// function buildUrl(url: any, param: any) {
//     var s = url;
//     if (param.length > 0) {
//         if (url.indexOf("?") > 0)
//             s += '&' + param;
//         else
//             s += '?' + param;
//     }
//     return s;
// }

function buildUrlReplace(url: any, searchFor: any, replaceWith: any) {
    var s = url;
        s = s.replace(searchFor, replaceWith)
    return s;
}

 function saveSurveyJson(url: string, json: string) {
    //NOTE: this is called from the save button built into the Creator component
     var result = "";
     $.ajax({
         method: "POST",
         async: false,
         url: url,
         data: JSON.stringify(json),
         contentType: 'application/json',
         headers: {
             'Content-Type': 'application/json'
         },
     })
         .done(function (msg: string) {
             result = msg;
             //TODO: handle error
             if (result.includes("Error"))
                    alert(msg);
             else {
                 SURVEY_DEFINITION_ID = msg;
                 notify("The survey has been saved!");
             }
             return result;
         }

     );
     return result;
}

function saveSurvey(url: string) {
    //NOTE: this is the save button at the top of the page that I added

    //Now save stuf
    var result = "";
    var json = JSON.stringify(_record);
    $.ajax({
        method: "POST",
        async: false,
        url: url,
        data: json,
        contentType: 'application/json',
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .done(function (msg: string) {
            result = msg;
            //TODO: handle error
            if (result.includes("Error"))
                   alert(msg);
            else {
                _record.id = msg;
                SURVEY_DEFINITION_ID = msg;

                notify("The survey has been saved!");
            }
            return result;
        }
    );
    return result;
}

function saveRecipientRules(url: string) {
    //NOTE: this is the save button at the top of the page that I added

    //Now save stuf
    var result = "";
    var json = JSON.stringify(_recipientRules);
    $.ajax({
        method: "POST",
        async: false,
        url: url,
        data: json,
        contentType: 'application/json',
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .done(function (msg: string) {
            result = msg;
            //TODO: handle error
            if (result.includes("Error"))
                   alert(msg);
            else {
            }
            return result;
        }
    );
    return result;
}

function saveRecipients(url: string) {
    //NOTE: this is the save button at the top of the page that I added

    //Now save stuf
    var result = "";
    var json = JSON.stringify(_recipients);
    $.ajax({
        method: "POST",
        async: false,
        url: url,
        data: json,
        contentType: 'application/json',
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .done(function (msg: string) {
            result = msg;
            //TODO: handle error
            if (result.includes("Error"))
                   alert(msg);
            else {
            }
            return result;
        }
    );
    return result;
}

function GetJsonResult(url: string) {
    var result = "";
    $.ajax({
        method: "GET",
        async: false,
        url: url,
        dataType: "json"
    })
        .done(function (msg) {
            result = msg;
            return result;
        });

    return result;
}

// Shorthand for $( document ).ready()
$(function() {
    
   
});


export default connect()(SurveyDefinition);
